var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigurationMobileNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4171_11373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.85547L17.25 8.99997L13.125 16.1445H4.875L0.75 8.99997L4.875 1.85547H13.125ZM12.2587 3.35547H5.74125L2.48175 8.99997L5.74125 14.6445H12.2587L15.5182 8.99997L12.2587 3.35547ZM6.4755 6.12747L7.7745 5.37747L11.5245 11.8725L10.2255 12.6225L6.4755 6.12747V6.12747Z",
    fill: "#080917"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4171_11373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurationMobileNav);
export default __webpack_public_path__ + "static/media/configuration-mobile-nav.7ff8e02d9b3b562ed7cad54be432de03.svg";
export { ForwardRef as ReactComponent };